import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { getAuthenticatedUser, resendEmailOtp } from "../api/auth";
import { setUser, logout as logoutUserSlice } from "../redux/slices/userSlice";
import { refreshDashboardDetails } from "../actions/user";
import * as bootstrap from "bootstrap";

const PrivateRoute = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userDetails = useSelector((state) => state.user.user);
  const [shouldRender, setShouldRender] = useState(false);
  const [isChecking, setIsChecking] = useState(true); 
  const dispatch = useDispatch();
  const hasFetchedUser = useRef(false);
  const pinModalHasOpened = useRef(false);

  useEffect(() => {
    let isMounted = true;

    const checkUser = async () => {
      if (!hasFetchedUser.current) {
        hasFetchedUser.current = true;
        try{
          const response = await getAuthenticatedUser();
          dispatch(setUser(response.data.data.user));
        }catch(err){
          dispatch(logoutUserSlice());
          navigate('/login');
        }
      }

      const user = userDetails;
      if (!user || Object.keys(user).length === 0){
        navigate("/login");
        return;
      }

      if (!user.email_verified_at && user.email) {
        localStorage.setItem("email", user.email);

        try {
          const response = await resendEmailOtp(user.email);
          // console.log(response);

          if (!isMounted) return;

          toast.success("Verify your email! Check your inbox.");
          navigate("/otp");
        } catch (error) {
          if (!isMounted) return;

          // console.error("Error resending OTP:", error);
          toast.error("Failed to resend OTP. Please try again.");
        }

        return;
      }

      if (isMounted) {
        setShouldRender(true);
      }
    };

    refreshDashboardDetails(dispatch);
    checkUser().finally(() => {
      if (isMounted) setIsChecking(false); // set after check completes
    });

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (!userDetails || userDetails.has_set_pin) return;
    // if (pinModalHasOpened.current) return;
    
    setTimeout(() => {
      const pinModal = document.getElementById("transactionPinModal");
      if (!pinModal) return;
      
      if (pinModal?.classList.contains("show")) return;

      const modal = bootstrap.Modal.getOrCreateInstance(pinModal);
      modal.show();
      // pinModalHasOpened.current = true;
    }, 5000);

  }, [location.pathname, userDetails]);
    
  // }, [userDetails, navigate]);

  // Prevent rendering anything until user check completes
  if (isChecking) return null;

  return shouldRender ? <Outlet /> : null;
};

export default PrivateRoute;